/* Taitiy 客户行为追踪 —— Google Apps Script 版（零服务器）
 * 与 Worker 版逻辑完全一致：捕获来路渠道 → 拦截加购/结账 → 记录浏览路径
 * 唯一区别：事件以 text/plain 形式 POST 到 GAS Web App（规避 CORS 预检，GAS 才能收到）
 * 配置：window.TAITIY_TRACK_ENDPOINT 在 theme.liquid 中设置（GAS Web App 的 /exec 地址）
 */
(function () {
  'use strict';

  var ENDPOINT = (window.TAITIY_TRACK_ENDPOINT || '').replace(/\/+$/, '');
  // 未配置或仍是占位地址时静默不发送，避免噪音
  if (!ENDPOINT || ENDPOINT.indexOf('YOUR_GAS_WEBAPP_ID') >= 0) return;

  var COOKIE_NAME = 'taitiy_attrib';
  var VID_KEY = 'taitiy_vid';
  var COOKIE_DAYS = 30;

  // 社媒域名识别
  var SOCIAL_MAP = [
    { re: /facebook\.com|fb\.me|m\.facebook/i, source: 'Facebook' },
    { re: /instagram\.com/i, source: 'Instagram' },
    { re: /tiktok\.com|vt\.tiktok/i, source: 'TikTok' },
    { re: /pinterest\.com/i, source: 'Pinterest' },
    { re: /twitter\.com|x\.com|t\.co/i, source: 'Twitter/X' },
    { re: /youtube\.com|youtu\.be/i, source: 'YouTube' },
    { re: /reddit\.com/i, source: 'Reddit' },
    { re: /whatsapp\.com|wa\.me/i, source: 'WhatsApp' },
    { re: /telegram\.org|t\.me/i, source: 'Telegram' },
    { re: /xiaohongshu\.com|xhslink\.com/i, source: '小红书' },
    { re: /weibo\.com/i, source: '微博' },
    { re: /weixin\.qq\.com|qq\.com/i, source: '微信/私域' }
  ];
  var SEARCH_MAP = [
    { re: /google\./i, source: 'Google' },
    { re: /bing\.com/i, source: 'Bing' },
    { re: /baidu\.com/i, source: 'Baidu' },
    { re: /yahoo\.com|search\.yahoo/i, source: 'Yahoo' },
    { re: /duckduckgo\.com/i, source: 'DuckDuckGo' },
    { re: /ecosia\.org/i, source: 'Ecosia' },
    { re: /yandex\./i, source: 'Yandex' }
  ];

  function uuid() {
    if (window.crypto && crypto.randomUUID) return crypto.randomUUID();
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = (Math.random() * 16) | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }
  function getVid() {
    try {
      var v = localStorage.getItem(VID_KEY);
      if (!v) { v = uuid(); localStorage.setItem(VID_KEY, v); }
      return v;
    } catch (e) { return uuid(); }
  }
  function getCookie(name) {
    try {
      var m = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
      return m ? decodeURIComponent(m[1]) : '';
    } catch (e) { return ''; }
  }
  function setCookie(name, val, days) {
    try {
      var d = new Date();
      d.setTime(d.getTime() + days * 864e5);
      document.cookie = name + '=' + encodeURIComponent(val) + ';expires=' + d.toUTCString() + ';path=/;SameSite=Lax';
    } catch (e) {}
  }
  function getParams() {
    try { return new URLSearchParams(location.search); } catch (e) { return new URLSearchParams(''); }
  }
  function classifySource(src) {
    src = (src || '').toLowerCase();
    for (var i = 0; i < SOCIAL_MAP.length; i++) if (SOCIAL_MAP[i].re.test(src)) return 'social';
    for (var j = 0; j < SEARCH_MAP.length; j++) if (SEARCH_MAP[j].re.test(src)) return 'search';
    if (/email/.test(src)) return 'email';
    return 'referral';
  }
  function resolveChannel() {
    var p = getParams();
    var utm_source = p.get('utm_source');
    var utm_medium = p.get('utm_medium');
    var utm_campaign = p.get('utm_campaign');
    var ref = document.referrer || '';
    var refHost = '';
    try { refHost = ref ? new URL(ref).hostname : ''; } catch (e) {}

    var ch = { source: 'Direct', medium: 'none', campaign: '', type: 'direct', referrer: refHost, landing: location.href };

    if (utm_source) {
      ch.source = utm_source;
      ch.medium = utm_medium || '(not set)';
      ch.campaign = utm_campaign || '';
      ch.type = classifySource(utm_source);
      return ch;
    }
    if (refHost) {
      for (var i = 0; i < SOCIAL_MAP.length; i++) {
        if (SOCIAL_MAP[i].re.test(refHost)) {
          ch.source = SOCIAL_MAP[i].source; ch.medium = 'social'; ch.type = 'social'; ch.referrer = refHost; return ch;
        }
      }
      for (var j = 0; j < SEARCH_MAP.length; j++) {
        if (SEARCH_MAP[j].re.test(refHost)) {
          ch.source = SEARCH_MAP[j].source; ch.medium = 'organic'; ch.type = 'search'; ch.referrer = refHost; return ch;
        }
      }
      ch.source = refHost; ch.medium = 'referral'; ch.type = 'referral'; ch.referrer = refHost; return ch;
    }
    return ch;
  }
  // first-touch：首次落地确定并持久化 30 天
  function getAttribution() {
    var stored = getCookie(COOKIE_NAME);
    if (stored) { try { return JSON.parse(stored); } catch (e) {} }
    var ch = resolveChannel();
    setCookie(COOKIE_NAME, JSON.stringify(ch), COOKIE_DAYS);
    return ch;
  }

  var ATTRIB = getAttribution();

  // 关键：GAS Web App 不能处理带预检(OPTIONS)的 application/json 请求，
  // 因此统一以 text/plain 字符串上报（sendBeacon / fetch no-cors 均不会触发预检）。
  function send(event, data) {
    try {
      var payload = {
        vid: getVid(),
        event: event,
        ts: Date.now(),
        url: location.href,
        path: location.pathname,
        channel: ATTRIB
      };
      if (data) for (var k in data) if (Object.prototype.hasOwnProperty.call(data, k)) payload[k] = data[k];
      var body = JSON.stringify(payload);
      if (navigator.sendBeacon) {
        // sendBeacon 传字符串 → Content-Type=text/plain，无预检，GAS 正常接收
        navigator.sendBeacon(ENDPOINT, body);
      } else {
        fetch(ENDPOINT, { method: 'POST', mode: 'no-cors', body: body }).catch(function () {});
      }
    } catch (e) {}
  }

  // ---- 解析加购请求体，提取 variant / quantity / 产品 handle ----
  function parseAddBody(body) {
    var info = { variant_id: '', quantity: 1, product_handle: '', title: document.title || '' };
    try {
      var m = location.pathname.match(/\/products\/([^/?#]+)/);
      if (m) info.product_handle = m[1];
    } catch (e) {}
    function read(fd) {
      if (fd && typeof fd.get === 'function') {
        info.variant_id = fd.get('id') || info.variant_id;
        info.quantity = parseInt(fd.get('quantity') || '1', 10) || 1;
      }
    }
    try {
      if (typeof FormData !== 'undefined' && body instanceof FormData) { read(body); return info; }
      if (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams) { read(body); return info; }
      if (typeof body === 'string') { read(new URLSearchParams(body)); return info; }
      if (body && typeof body === 'object') {
        info.variant_id = body.id || (body.items && body.items[0] && body.items[0].id) || info.variant_id;
        info.quantity = body.quantity || (body.items && body.items[0] && body.items[0].quantity) || 1;
        return info;
      }
    } catch (e) {}
    return info;
  }

  // ---- 拦截 fetch ----
  var nativeFetch = window.fetch ? window.fetch.bind(window) : null;
  if (nativeFetch) {
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var method = (init && init.method) || (input && input.method) || 'GET';
      var promise = nativeFetch(input, init);
      try {
        if (/\/cart\/add(\.js)?(\?|$)/.test(url) && /post/i.test(method)) {
          promise.then(function (resp) {
            if (resp && resp.ok) send('add_to_cart', parseAddBody(init && init.body));
            return resp;
          }).catch(function () {});
        }
        if (/\/cart(\.js)?$/.test(url) && /post/i.test(method)) {
          var b = init && init.body;
          var s = typeof b === 'string' ? b : (b && JSON.stringify(b)) || '';
          if (/checkout/.test(s) && !/update/.test(s)) send('checkout_started', {});
        }
      } catch (e) {}
      return promise;
    };
  }

  // ---- 拦截 XMLHttpRequest（部分主题用 XHR） ----
  var nativeOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    this._tty_method = method; this._tty_url = url;
    return nativeOpen.apply(this, arguments);
  };
  var nativeSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function (body) {
    var xhr = this;
    try {
      if (/\/cart\/add/.test(xhr._tty_url || '') && /post/i.test(xhr._tty_method || '')) {
        xhr.addEventListener('load', function () {
          if (xhr.status >= 200 && xhr.status < 300) send('add_to_cart', parseAddBody(body));
        });
      }
      if (/\/cart/.test(xhr._tty_url || '') && /post/i.test(xhr._tty_method || '')) {
        var s = typeof body === 'string' ? body : (body && JSON.stringify(body)) || '';
        if (/checkout/.test(s) && !/update/.test(s)) send('checkout_started', {});
      }
    } catch (e) {}
    return nativeSend.apply(this, arguments);
  };

  // ---- 结账按钮兜底监听 ----
  function onCheckoutIntent() { send('checkout_started', {}); }
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t) return;
    var el = t.closest ? t.closest('a,button') : null;
    var sel = el ? el.getAttribute('href') || el.getAttribute('name') || el.className || '' : '';
    if (/checkout/i.test(sel) || (el && /checkout/i.test(el.textContent || ''))) onCheckoutIntent();
  }, true);

  // ---- 浏览路径 ----
  var lastPath = '';
  function trackView(type) {
    if (location.pathname === lastPath && type !== 'landing') return;
    lastPath = location.pathname;
    send('page_view', { page_type: type });
  }
  // 落地页
  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    trackView('landing');
  } else {
    window.addEventListener('load', function () { trackView('landing'); });
  }
  // PJAX 导航（本店 taitiy-cat-pjax 若派发此事件）
  document.addEventListener('pjax:end', function () { trackView('navigation'); });
  // 前进/后退
  window.addEventListener('popstate', function () { setTimeout(function () { trackView('navigation'); }, 0); });
})();
